import Section from "../Section/Section";
import { EDUCATIONS, COURSES } from "../../../config/constants";
import Certification from "./Certification";
import SectionTitle from "../../common/SectionTitle";

export default function Education() {
  return (
    <Section id="education" className="w-full gap-6">
      <div>
        <SectionTitle>Educación</SectionTitle>
        <div className="flex flex-col gap-3">
          {EDUCATIONS.map((ed, index) => (
            <Certification
              key={index}
              title={ed.title}
              institution={ed.institution}
              startYear={ed.startYear}
              endYear={ed.endYear}
            />
          ))}
        </div>
      </div>

      <div>
        <SectionTitle>Certificaciones</SectionTitle>
        <div className="flex flex-col gap-3">
          {COURSES.map((ed, index) => (
            <Certification
              key={index}
              title={ed.title}
              institution={ed.institution}
              startYear={ed.startYear}
              endYear={0}
            />
          ))}
        </div>
      </div>
    </Section>
  );
}
